export * from './deviations-table'
